import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
// import {Vendors} from './vendors/vendors.entity';
import { Grades } from './grades/grades.entity';
// import { VendorsModule } from './vendors/vendors.module';
import { GradesModule } from './grades/grades.module';
import { CurrenciesModule } from './currencies/currencies.module';
import { Currencies } from './currencies/currencies.entity';
import { CountriesModule } from './countries/countries.module';
import { Countries } from './countries/countries.entity';
import { Variant } from './item-varient/item-variant.entity';
import { ItemVariantModule } from './item-varient/item-variant.module';
import { Departments } from './departments/departments.entity';
import { Uoms } from './uoms/uom.entity';
import { Taxes } from './taxes/taxes.entity';
import { TaxesModule } from './taxes/taxes.module';
import { UomsModule } from './uoms/uoms.module';
import { DepartmentsModule } from './departments/departments.module';
import { EmployeeDetails } from './employee-details/employee-details.entity';
import { EmployeeDetailsModule } from './employee-details/employee-details.module';
import { FoodType } from './food-types/food-types.entitiy';
import { FoodTypesModule } from './food-types/food-types.module';
import { ValueAdditionOneType } from './value-addition1-types/value-addition-one.entity';
import { ValueAddition1TypesModule } from './value-addition1-types/value-addition1-types.module';
import { ValueAdditionTwoType } from './value-addition2-types/value-addition-two.entity';
import { ValueAddition2TypesModule } from './value-addition2-types/value-addition2-types.module';
import { PaymentMode } from './payment-mode/payment-mode.entity';
import { PaymentModeModule } from './payment-mode/payment-mode.module';
import { SaleorderType } from './sale-order-type/sale-order-type.entity';
import { SaleOrderTypeModule } from './sale-order-type/sale-order-type.module';
import { ValueAdditionThreeType } from './value-addition3-types/value-addition-three.entity';
import { ValueAddition3TypesModule } from './value-addition3-types/value-addition3-types.module';
import { ValueAdditionFourType } from './value-addition4-types/value-addition-four.entity';
import { ValueAddition4TypesModule } from './value-addition4-types/value-addition4-types.module';
import { Product } from './products/product.entity';
import { ProductsModule } from './products/products.module';
import { PackingMathodsModule } from './packing-mathods/packing-mathods.module';
import { PackingMethod } from './packing-mathods/packing-methods.entity';
import { ItemCategoriesModule } from './item-categories/item-categories.module';
import { ItemsModule } from './items/items.module';
import { ItemDamageReasonsModule } from './item-damage-reasons/item-damage-reasons.module';
import { GrnRejectionReasonsModule } from './grn-rejection-reasons/grn-rejection-reasons.module';
import { CustomersModule } from './customers/customers.module';
import { RacksModule } from './racks/racks.module';
import { CellsModule } from './cells/cells.module';
import { LevelModule } from './level/level.module';
import { RackCellMappingModule } from './rack-cell-mapping/rack-cell-mapping.module';
import { VehicleMasterModule } from './vehicle-master/vehicle-master.module';
import { ZoneMasterModule } from './zone-master/zone-master.module';
import { Rack } from './racks/racks.entity';
import { Cell } from './cells/cells.entity';
import { Level } from './level/level.entity';
import { RackCellMap } from './rack-cell-mapping/rack-cell-mapping.entity';
import { ItemCategory } from './item-categories/item-categories.entity';
import { Item } from './items/item.entity';
import { DamageReason } from './item-damage-reasons/item-damage-reason.entity';
import { Customers } from './customers/customers.entity';
import { VehicleMaster } from './vehicle-master/vehicle-master.entity';
import { ZoneMaster } from './zone-master/zone-master.entity';
import { GrnRejectionReason } from './grn-rejection-reasons/grn-rejection-reason.entity';
import { DestinationModule } from './destination/destination.module';
import { Destination } from './destination/destination.entity';
import { SkuCodesModule } from './sku-codes/sku-codes.module';
import { CertificatesModule } from './certificates/certificates.module';
import { Certificates } from './certificates/certificates.entity';
import { SkuCodes } from './sku-codes/sku-codes.entity';
import { ShippingTermsModule } from './shipping-terms/shipping-terms.module';
import { ShippingTerms } from './shipping-terms/shipping-terms.entity';
import { DeliveryTermsModule } from './delivery-terms/delivery-terms.module';
import { PaymentTermsModule } from './payment-terms/payment-terms.module';
import { DeliveryTerms } from './delivery-terms/delivery-terms.entity';
import { PaymentTerms } from './payment-terms/payment-terms.entity';
import { Address } from './customers/address.entity';
import { UnitCodesModule } from './unit-codes/unit-codes.module';
import { UnitCodes } from './unit-codes/unit-codes.entity';
import { Vendors } from './vendors/vendors.entity';
import { VendorsModule } from './vendors/vendors.module'
import { EndCustomersModule } from './end-customer/end-customer.module';
import { Brands } from './end-customer/brands.entity';
import { EndCustomers } from './end-customer/end-customer.entity';
import { SizesModule } from './sizes/sizes.module';
import { Sizes } from './sizes/sizes-entity'
import { SaleOrderProcessTypeModule } from './sale-order-process-type/sale-order-process-type.module';
import { SaleorderprocessType } from './sale-order-process-type/sale-order-process-type.entity';
import { ValueAddition5TypesModule } from './value-addition5-types/value-addition5-types.module';
import { ValueAdditionFiveType } from './value-addition5-types/value-addition-five.entity';
import { VendorsPriceListModule } from './vendors-price-list/vendors-price-list.module';
import { VendorsPriceList } from './vendors-price-list/entities/vendor-price-list.entity';
import { LoggerModule, PinoLogger } from 'nestjs-pino';
import mastersConfigs from '../../config';
import { QueryLogger } from '../../../logger/query-logger';
import { PalletsModule } from './pallets/pallets.module';
import { Roles } from './role-master/role-entity';
import { RoleMasterModule } from './role-master/role-master.module';
import { appSettings } from '../../../config';
//import { Pallets } from './pallets/pallets.entity';
import { ColumnsModule } from './columns/columns.module';
import { Columns } from './columns/colunms.entity';
import { RackZoneMappingModule } from './rack-zone-mapping/rack-zone-mapping.module';
import { RackZoneMapping } from './rack-zone-mapping/rack-zone-mapping-entity';
import { LocationsModule } from './locations/locations.module';
import { Locations } from './locations/location.entity';
import { MasterBrandsModule } from './master-brands/master-brands.module';
import { MasterBrand } from './master-brands/master-brands.entity';
import { HlPercentagesModule } from './hl-percentages/hl-percentages.module';
import { HlPercentage } from './hl-percentages/hl-percentage.entity';
import { HatcheriesModule } from './hatcheries/hatcheries.module';
import { Hatcheries } from './hatcheries/hatcheries.entity';
import { SuppliersModule } from './suppliers/suppliers.module';
import { Supplier } from './suppliers/supplier.entity';
import { Farm } from './suppliers/farms.entity';
import { Pallet } from './pallets/pallets.entity';
import { HistoryServiceModule } from './history-service/history-service.module';
import { DimensionServiceModule } from './dimension-service/dimension-service.module';
import { History } from './history-service/history-service.entity';
import { Dimension } from './dimension-service/dimension-service.entity';
import { DeviceModule } from './device/device.module';
import { Device } from './device/device.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RackPositionModule } from './rack-position/rack-position.module';
import { RackPosition } from './rack-position/rack-position.entity';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { IdProofsModule } from './id-proofs/id-proofs.module';
import { IdProofTypes } from './id-proofs/id-proofs-type.entity';
import { Qualifications } from './qualifications/qualifications.entity';
import { QualificationModule } from './qualifications/qualifications.module';
import { RecruitmentModule } from './mode/recruitment/recruitment.module';
import { ItemSubCategoriesModule } from './item-sub-categories/item-sub-categories.module';
import { ItemSubCategory } from './item-sub-categories/item-sub-category.entity';
import { RelationsModule } from './relations/relations.module';
import { Relations } from './relations/relation.entity';
import { Recruitment } from './mode/recruitment/recruitment.entity';
import { HsnCodesModule } from './hsn-codes/hsn-codes.module';
import { HsnCodes } from './hsn-codes/hsn-codes.entity';
import { InsuranceModule } from './insurance/insurance.module';
import { Insurance } from './insurance/dto/insurance.entity';
import { ReasonsModule } from './reasons/reasons.module';
import { Reasons } from './reasons/reasons.entity';
import { EmployeeFamilyDetails } from './employee-details/employee-family-details.entity';
import { EmployeeIdProofDetails } from './employee-details/employee-id-proof-details.entity';
import { EmployeeEducationDetails } from './employee-details/employee-education-details.entity';
import { EmployeeExperienceDetails } from './employee-details/employee-experience-details.entity';
import { RmToleranceModule } from './rm-tolerance/rm-tolerance.module';
import { RmTolerance } from './rm-tolerance/rm-tolerance.entity';
import { GradeSuggestionModule } from './grade-suggestion/grade-suggestion.module';
import { GradeSuggestion } from './grade-suggestion/grade-suggestion.entity';
import { PlantOperationCapacityModule } from './plant-operation-capacity/plant-operation-capacity.module';
import { PlantOperationCapacity } from './plant-operation-capacity/plant-operation-capacity.entity'
import { RmPriceListModule } from './rm-price-list/rm-price-list.module';
import { RmPriceList } from './rm-price-list/rm-price-list.entity';

import { SkuCodesDetail } from './sku-codes/sku-details.entity';

import { TrimsModule } from './shrimps/trims.module';
import { PalletCapacityModule } from './pallet-capacity/pallet-capacity.module';
import { PalletCapacity } from './pallet-capacity/pallet-capacity.entity';
import { Trims } from './shrimps/trims.entity';
import { BrandsTrims } from './master-brands/brands-trims.entity';
import { NotifyParty } from './notify-party/notify-party.entity';
import { NotifyPartyModule } from './notify-party/notify-party.module';
import { Types } from './types/types.entity';
import { TypesModule } from './types/types.module';
import { DowntimeReasonModule } from './downtime-reason/downtimereason.module';
import { DownTimeReason } from './downtime-reason/dto/downtimereason.entity';
import { DownTimeTracking } from './downtime-tracking/dto/downtime-tracking.entity';
import { DownTimeTrackingModule } from './downtime-tracking/downtime-tracking.module';
import { SpecSheet } from './spec-sheet/dto/spec-sheet.entity';
import { SpecSheetModule } from './spec-sheet/spec-sheet.module';
import { Sample } from './locations/sample.entity';
import { SupplierCreation } from './supplier-mapping/supplier-creation.entity';
import { SupplierMappingModule } from './supplier-mapping/supplier-mapping.module';
import { JwtModule } from '@nestjs/jwt';
import { TrimsMapping } from './trims-configuration/trims-configuration.entity';
import { TrimItemsMapping } from './trims-configuration/trims-item-configuration.entity';
import { TrimsConfiguraionModule } from './trims-configuration/trims-configuration.module';
import { RmLevel } from './rm-level/rm-level-entity';
import { RmLevelModule } from './rm-level/rm-level-module';
import { RmColumnsModule } from './rm-columns/rm-columns-module';
import { RmColumns } from './rm-columns/rm-columns-entity';
import { RmRackPosition } from './rm-rack-position/rm-rack-position.entity';
import { RmRack } from './rm-racks/rm-racks.entity';
import { RmRackPositionModule } from './rm-rack-position/rm-rack-position.module';
import { RmRacksModule } from './rm-racks/rm-racks.module';
import { RmZonesService } from './rm-zones/rm-zones.service';
import { RmZones } from './rm-zones/rm-zones.entity';
import { RMZonesModule } from './rm-zones/rm-zones.module';
import { Defect } from './defect/defect.entity';
import { DefectModule } from './defect/defect.module';
import { RmRackPositionLog } from './rm-rack-position/rm-rack-position-log.entity';
import { CalibrationModule } from './calibration/calibration.module';
import { Calibrations } from './calibration/calibration.entity';
import { EmployeeSkillMatrix } from './employee-details/employee-skill-matrix.entity';
import { join } from 'path';
import * as fs from 'fs';
import { ServeStaticModule } from '@nestjs/serve-static';
import { AssetCheckListModule } from './asset-checklist/asset-checklist.module';
import { AssetCheckListEntity } from './asset-checklist/asset-checklist.entity';
import { CheckListModelModule } from './check-list-model/checklist-model.module';
import { CheckListModelEntity } from './check-list-model/checklist-model.entity';
import { EmployeeTrainingEntity } from './employee-details/employee-training-entity';

console.log(__dirname)
if (!fs.existsSync('masters-upload-files')) {
  fs.mkdirSync('masters-upload-files')
}

@Module({
  imports: [
    // LoggerModule.forRoot({ pinoHttp: { level: mastersConfigs.loggingMode } }),
    ServeStaticModule.forRoot({
      rootPath: join(__dirname, '../../../../../', "masters-upload-files"),
    }),
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.masters_db,
      entities: [DownTimeReason, DownTimeTracking, SpecSheet, RmLevel, RmColumns,
        Departments, SaleorderprocessType, Countries, Sizes, Currencies, Variant, Vendors, Grades, Uoms, Taxes, EmployeeDetails, PaymentMode, SaleorderType, Variant, FoodType, ValueAdditionOneType, ValueAdditionTwoType, ValueAdditionThreeType, ValueAdditionFourType, Product, PackingMethod, Rack, Cell, Level, RackCellMap, ItemCategory, Item, DamageReason, Customers, Address, VehicleMaster, ZoneMaster, GrnRejectionReason, Destination, Certificates, SkuCodes, DeliveryTerms, UnitCodes, PaymentTerms, ShippingTerms, EndCustomers, Brands, ValueAdditionFiveType, VendorsPriceList, Pallet, Columns, RackZoneMapping, Locations, Roles, MasterBrand, HlPercentage, Hatcheries, Supplier, Farm, History, Dimension, Device, RackPosition, ItemSubCategory, Recruitment, Relations, IdProofTypes, Qualifications, HsnCodes, Insurance, Reasons, EmployeeFamilyDetails, EmployeeIdProofDetails, EmployeeEducationDetails, EmployeeExperienceDetails, RmTolerance, GradeSuggestion, PlantOperationCapacity, RmPriceList, SkuCodesDetail, PalletCapacity, Trims, BrandsTrims, NotifyParty, Types, Sample, SupplierCreation, TrimsMapping, TrimItemsMapping, RmRackPosition, RmRack, RmZones, Defect, RmRackPositionLog, Calibrations,AssetCheckListEntity,CheckListModelEntity,EmployeeSkillMatrix,EmployeeTrainingEntity],
      // synchronize: mastersConfigs.sync,
      synchronize: false,


      logging: true,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: mastersConfigs.loggingMode } })),/
    }
    ),
    TypeOrmModule.forFeature([Pallet, RackPosition, Dimension]),

    EmployeeDetailsModule,
    PaymentModeModule,
    DestinationModule,
    SaleOrderTypeModule,
    TaxesModule, DepartmentsModule, UomsModule, ItemVariantModule, GradesModule, CountriesModule, CurrenciesModule, ItemVariantModule,
    FoodTypesModule,
    ValueAddition1TypesModule,
    ValueAddition2TypesModule,
    ValueAddition3TypesModule,
    ValueAddition4TypesModule,
    ProductsModule,
    PackingMathodsModule,
    ItemCategoriesModule,
    ItemsModule,
    ItemDamageReasonsModule,
    GrnRejectionReasonsModule,
    CustomersModule,
    RacksModule,
    CellsModule,
    LevelModule,
    RackCellMappingModule,
    VehicleMasterModule,
    ZoneMasterModule,
    DestinationModule,
    EndCustomersModule,
    SkuCodesModule,
    DowntimeReasonModule,
    DownTimeTrackingModule,
    SpecSheetModule,
    RmLevelModule,
    RmColumnsModule,
    CertificatesModule, DeliveryTermsModule, PaymentTermsModule, ShippingTermsModule, UnitCodesModule, VendorsModule, SizesModule, SaleOrderProcessTypeModule, ValueAddition5TypesModule, VendorsPriceListModule, PalletsModule, ColumnsModule, RackZoneMappingModule, LocationsModule, RoleMasterModule, MasterBrandsModule, HlPercentagesModule, HatcheriesModule, SuppliersModule, HistoryServiceModule, DimensionServiceModule, DeviceModule, RackPositionModule, ItemSubCategoriesModule, RecruitmentModule, RelationsModule, IdProofsModule, QualificationModule, HsnCodesModule, InsuranceModule, ReasonsModule, RmToleranceModule, GradeSuggestionModule, PlantOperationCapacityModule, RmPriceListModule, TrimsModule, PalletCapacityModule, NotifyPartyModule, TypesModule, SupplierMappingModule, TrimsConfiguraionModule, RmRackPositionModule, RmRacksModule, RMZonesModule, DefectModule, CalibrationModule,AssetCheckListModule, CheckListModelModule],


  controllers: [AppController],
  providers: [AppService, ApplicationExceptionHandler, FGStockService],
})

export class AppModule { }